import { render, staticRenderFns } from "./ConsumerList.vue?vue&type=template&id=946f6908&"
import script from "./ConsumerList.vue?vue&type=script&lang=js&"
export * from "./ConsumerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports